module.exports = __webpack_public_path__ + "img/shoulder_width.b61d0a59.png";